var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronLeftFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5378 7.98076L9.16363 10.3549C8.80613 10.7124 8.80613 11.2899 9.16363 11.6474L11.5378 14.0216C12.1153 14.5991 13.1053 14.1866 13.1053 13.3708V8.62242C13.1053 7.80659 12.1153 7.40326 11.5378 7.98076Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeftFilledIcon);
export default __webpack_public_path__ + "static/media/ChevronLeftFilledIcon.94e0a4e0a6d974eed0fd00bfea14d093.svg";
export { ForwardRef as ReactComponent };